<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 23"
        :class="customClasses"
    >
        <path fill="#FFF" fill-rule="evenodd" d="M19.043 22.885a.603.603 0 0 1-.355-.116L12 17.911l-6.688 4.858a.606.606 0 0 1-.93-.675l2.555-7.862L.249 9.373A.604.604 0 0 1 .604 8.28h8.267L11.425.417a.605.605 0 0 1 1.15 0l2.554 7.862h8.267a.604.604 0 0 1 .355 1.094l-6.687 4.859 2.554 7.862a.605.605 0 0 1-.575.791z"/>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
            })

            return {
                customClasses
            }
        }
    })
</script>